// extracted by mini-css-extract-plugin
module.exports = {"container":"_1INZOi3Ck-KKtqFV5uZaos","imageContainer":"_2T2j5vWKHzYxscyXRTDLKd","titleContainer":"_1ZkA6guYpt7yX_PLjqzB2A","authorDate":"_2swwkuQPl-iEAS7YhF8kHI"};